import { render, staticRenderFns } from "./BiologicalWarningReport.vue?vue&type=template&id=17c70c6f&scoped=true"
import script from "./BiologicalWarningReport.vue?vue&type=script&lang=js"
export * from "./BiologicalWarningReport.vue?vue&type=script&lang=js"
import style0 from "./BiologicalWarningReport.vue?vue&type=style&index=0&id=17c70c6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c70c6f",
  null
  
)

export default component.exports